export class TakeNativeSnapshotRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "targetRegion",
            "baseName": "targetRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultProtectionMode",
            "baseName": "vaultProtectionMode",
            "type": "TakeNativeSnapshotRequestVaultProtectionModeEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TakeNativeSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var TakeNativeSnapshotRequestVaultProtectionModeEnum;
(function (TakeNativeSnapshotRequestVaultProtectionModeEnum) {
    TakeNativeSnapshotRequestVaultProtectionModeEnum["None"] = "none";
    TakeNativeSnapshotRequestVaultProtectionModeEnum["VaultLockGovernance"] = "vault-lock-governance";
    TakeNativeSnapshotRequestVaultProtectionModeEnum["VaultLockCompliance"] = "vault-lock-compliance";
    TakeNativeSnapshotRequestVaultProtectionModeEnum["AirGapped"] = "air-gapped";
})(TakeNativeSnapshotRequestVaultProtectionModeEnum || (TakeNativeSnapshotRequestVaultProtectionModeEnum = {}));
